/**
 * S - Portra 160⁺¹ - — VSCO Film 06 Push & Pull - Standard
 *
 * Generated by `tools/xmp-to-preset.mjs` from `Portra 160+1 -.xmp`.
 * Keys are Adobe's own `crs:` names so this can be diffed against the source
 * `.xmp` by eye. Compiled by `src/js/fx/cameraRawGrade.js`.
 *
 * Carried in the preset but NOT reproduced:
 *   CameraProfile = Portra 160⁺¹ — camera profile — a binary .dcp we cannot read
 *   GrainAmount = 5 — film grain — the sim has its own grain pass
 */

export default {
  name: "S - Portra 160⁺¹ -",
  Saturation: 0,
  RedHue: 30,
  RedSaturation: -10,
  GreenHue: 50,
  GreenSaturation: -10,
  BlueHue: -12,
  BlueSaturation: -15,
  Vibrance: 0,
  HueAdjustmentRed: 8,
  HueAdjustmentOrange: 12,
  HueAdjustmentYellow: 10,
  HueAdjustmentGreen: 15,
  HueAdjustmentAqua: 5,
  HueAdjustmentBlue: -4,
  HueAdjustmentPurple: 10,
  HueAdjustmentMagenta: 25,
  SaturationAdjustmentRed: -20,
  SaturationAdjustmentOrange: -2,
  SaturationAdjustmentYellow: -5,
  SaturationAdjustmentGreen: -20,
  SaturationAdjustmentAqua: -10,
  SaturationAdjustmentBlue: -10,
  SaturationAdjustmentPurple: 0,
  SaturationAdjustmentMagenta: -20,
  LuminanceAdjustmentRed: -20,
  LuminanceAdjustmentOrange: -2,
  LuminanceAdjustmentYellow: 0,
  LuminanceAdjustmentGreen: 0,
  LuminanceAdjustmentAqua: 0,
  LuminanceAdjustmentBlue: -10,
  LuminanceAdjustmentPurple: 0,
  LuminanceAdjustmentMagenta: 0,
  SplitToningShadowHue: 0,
  SplitToningShadowSaturation: 0,
  SplitToningHighlightHue: 0,
  SplitToningHighlightSaturation: 0,
  SplitToningBalance: 0,
  ParametricShadows: -15,
  ParametricDarks: 4,
  ParametricLights: 0,
  ParametricHighlights: -5,
  ParametricShadowSplit: 20,
  ParametricMidtoneSplit: 48,
  ParametricHighlightSplit: 75,
  Contrast2012: 0,
  Highlights2012: -30,
  Shadows2012: 30,
  Whites2012: -25,
  Blacks2012: 25,
  ConvertToGrayscale: false,
  ToneCurvePV2012: [
    "0, 0",
    "21, 29",
    "51, 61",
    "91, 97",
    "168, 170",
    "255, 255",
  ],
  ToneCurvePV2012Red: [
    "0, 0",
    "47, 18",
    "80, 62",
    "117, 122",
    "179, 200",
    "255, 255",
  ],
  ToneCurvePV2012Green: [
    "0, 0",
    "46, 20",
    "117, 122",
    "179, 200",
    "255, 255",
  ],
  ToneCurvePV2012Blue: [
    "0, 0",
    "44, 18",
    "80, 63",
    "117, 122",
    "179, 200",
    "255, 255",
  ],
};
